import { FormEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogin } from "../api/auth";
import { errorMessage } from "../api/client";
import BrandLogo from "../components/BrandLogo";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const login = useLogin();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? "/";

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    login.mutate(
      { username, password },
      { onSuccess: () => navigate(from, { replace: true }) },
    );
  }

  return (
    <div className="login-wrap">
      {/* on the deep-green page bg: chrome.css paints .brand-word/.brand-hub white */}
      <div className="brand login-brand">
        <BrandLogo className="brand-logo login-logo" />
        <span className="brand-word">
          Gravando<span className="brand-accent">&nbsp;AI</span>
        </span>
        <span className="brand-hub">Console</span>
      </div>
      <form className="card login-card" onSubmit={onSubmit}>
        <label className="field">
          <span className="field-label">Email</span>
          <input
            className="text-input"
            type="email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="email"
            autoFocus
            required
          />
        </label>
        <label className="field">
          <span className="field-label">Password</span>
          <input
            className="text-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {login.isError && <p className="error">{errorMessage(login.error)}</p>}
        <button className="btn primary login-submit" type="submit" disabled={login.isPending}>
          {login.isPending ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
